import { CustomerModel } from '@/http/models/customer'
import { useParams } from 'react-router-dom'

import { useEffect } from 'react'

import { useHttp } from '@/hooks'

import {
  CustomerActivityTabs,
  CustomerDetailHeader,
  CustomerDetailSkeleton,
  CustomerNotFound,
  CustomerProfileCard,
  CustomerStatsCards,
} from '@/components/features/customers/detail'

import { CustomerModel as CustomerModelType } from '@/types'

export const CustomerDetail = () => {
  const { id } = useParams()

  // Fetch customer details using useHttp
  const { loading, individual } = useHttp<CustomerModelType.Customer>({
    correlation: CustomerModel.correlations.GET_BY_ID,
    type: 'individual',
    clearOnUnmount: true,
  })

  useEffect(() => {
    if (id) {
      CustomerModel.getById({
        params: { id },
        store: true,
      })
    }
  }, [id])

  const customer = individual?.result

  if (loading) {
    return <CustomerDetailSkeleton />
  }

  if (!customer) {
    return <CustomerNotFound />
  }

  return (
    <div className="mx-auto w-full max-w-[1088px] pb-10">
      <CustomerDetailHeader title={customer.name} />

      <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_288px] lg:gap-6">
        <div className="min-w-0 space-y-4">
          <CustomerStatsCards customer={customer} />
          <CustomerActivityTabs />
        </div>

        <div className="min-w-0 space-y-4">
          <CustomerProfileCard customer={customer} />
        </div>
      </div>
    </div>
  )
}
